<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Details" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <Form class="form form-horizontal" v-slot="{ meta,errors  }" @submit="sendCall" :initial-values="{email: $store.getters.getUpdateStaffData.email, phoneNumber : $store.getters.getUpdateStaffData.phone_number, firstName : $store.getters.getUpdateStaffData.first_name, lastName : $store.getters.getUpdateStaffData.last_name,status : $store.getters.getUpdateStaffData.status}">
                    <div class="row">
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label>Email</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <Field-->
<!--                                  class="form-control"-->
<!--                                  type="text"-->
<!--                                  name="email"-->
<!--                                  rules="required|email"-->
<!--                                  :class="(errors.email && !meta.valid && meta.touched)? 'is-invalid': ''"-->
<!--                              >-->
<!--                              </Field>-->
<!--                            </div>-->
<!--                            <ErrorMessage as="small" class="text-danger" name="email"/>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label>Phone</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <Field-->
<!--                                  class="form-control"-->
<!--                                  type="text"-->
<!--                                  name="phoneNumber"-->
<!--                                  rules="required|numeric"-->
<!--                                  :class="(errors.phoneNumber && !meta.valid && meta.touched)? 'is-invalid': ''"-->
<!--                              >-->
<!--                              </Field>-->
<!--                            </div>-->
<!--                            <ErrorMessage as="small" class="text-danger" name="phoneNumber"/>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>First Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <Field
                                  class="form-control"
                                  type="text"
                                  name="firstName"
                                  rules="required|alpha"
                                  :class="(errors.firstName && !meta.valid && meta.touched)? 'is-invalid': ''"
                              >
                              </Field>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="firstName"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Last Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <Field
                                  class="form-control"
                                  type="text"
                                  name="lastName"
                                  rules="required|alpha"
                                  :class="(errors.lastName && !meta.valid && meta.touched)? 'is-invalid': ''"
                              >
                              </Field>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="lastName"/>
                          </div>
                        </div>
                      </div>
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label>Password</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <Field-->
<!--                                  class="form-control"-->
<!--                                  type="text"-->
<!--                                  name="password"-->
<!--                                  rules="required|min:8"-->
<!--                                  :class="(errors.password && !meta.valid && meta.touched)? 'is-invalid': ''"-->
<!--                              >-->
<!--                              </Field>-->
<!--                            </div>-->
<!--                            <ErrorMessage as="small" class="text-danger" name="password"/>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label>Confirm Password</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <Field-->
<!--                                  class="form-control"-->
<!--                                  type="text"-->
<!--                                  name="confirmPassword"-->
<!--                                  rules="required|confirmed:@password"-->
<!--                                  :class="(errors.confirmPassword && !meta.valid && meta.touched)? 'is-invalid': ''"-->
<!--                              >-->
<!--                              </Field>-->
<!--                            </div>-->
<!--                            <ErrorMessage as="small" class="text-danger" name="confirmPassword"/>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Status</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <Field as="select"  rules="required" name="status" class="form-control" :class="(errors.status && !meta.valid && meta.touched)? 'is-invalid': ''">
                                <option value>Select Status</option>
                                <option value="0">Pending</option>
                                <option value="1">Active</option>
                                <option value="2">Inactive</option>
                                <option value="3">Suspended</option>
                              </Field>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="status"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3">
                        <Button class="btn btn-primary mr-1" :loading="loader">Save</Button>
                        <button
                            type="button"
                            class="btn btn-gradient-secondary"
                            @click="$router.push({ name: 'merchant-staff' })"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
export default {
  computed: {
    staffLabel() {
      return this.$store.getters.isPayfacMerchant ? 'Sub Merchants' : 'Merchant Staff'
    },
    breadcrumb() {
      return [
        {name: 'App'},
        {name: this.staffLabel},
        {name: 'Update'},
      ]
    },
  },
  mounted() {
    let staff = this.$store.getters.getUpdateStaffData
    if(staff.status == 1){
      this.status = true
    }else {
      this.status = false
    }
  },
  data() {
    return {
      loader: false,
      status: false,
      initialValues : {}

    }
  },
  methods: {
    sendCall(values) {
      let data = values
      data.userId = this.$store.getters.getUpdateStaffData.id
      this.loader = true
      this.makeRequest('post', 'v1/update-merchant-staff', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.$router.push({name: 'merchant-staff'});
          }
        }

      });

    },
  },
}
</script>

